<template>
  <div>
    <b-form-radio-group
      v-model="mode"
      data-cy="TableMap-switch"
      :options="radioOptions"
      button-variant="outline-secondary"
      size="md"
      html-field="text"
      class="switchButton"
      name="radio-btn-outline"
      buttons
    ></b-form-radio-group>
    <Table
      v-if="mode === 'table'"
      class="py-3 text-left"
      :items="measures"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :total-rows="totalRows"
      @page-changed="onPageChanged"
      @per-page-changed="onPerPageChanged"
    />
    <Map ref="map" v-else>
      <template v-slot:marker>
        <l-marker
          data-cy="marker"
          :name="marker.name"
          v-bind:lat-lng="marker.location"
          v-bind:options="{ id: marker.id }"
          :icon="markerIcon"
          :ref="marker.id"
        >
        </l-marker>
        <l-marker
          v-for="(marker, index) of measures"
          :key="`marker-${index}`"
          data-cy="marker"
          :name="`marker-${index}`"
          v-bind:lat-lng="marker.measure"
          v-bind:options="{ id: `marker-${index}` }"
          :icon="icon"
          :ref="`marker-${index}`"
        >
          <l-tooltip>
            {{ marker.date }}
          </l-tooltip>
        </l-marker>
        <l-polyline :lat-lngs="polylineLocations" class="lineColor">
        </l-polyline>
      </template>
    </Map>
  </div>
</template>

<script>
import shadowUrl from 'leaflet/dist/images/marker-shadow.png';
import L from 'leaflet';
import { LMarker, LPolyline, LTooltip } from 'vue2-leaflet';
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster';
export default {
  name: 'MapView',
  components: {
    LMarker,
    LTooltip,
    // 'v-marker-cluster': Vue2LeafletMarkerCluster,
    LPolyline
  },
  props: {
    measures: {
      required: true
    },
    asset: {
      required: true
    },
    currentTabType: {
      required: true
    },
    fields: {
      required: true
    },
    currentPage: {
      required: true
    },
    perPage: {
      required: true
    },
    totalRows: {
      required: true
    }
  },
  methods: {
    fitMapBounds() {
      const visibleMarkers = [];
      this.$refs.map.$refs.map.mapObject.eachLayer(function(layer) {
        if (layer instanceof L.Marker) {
          visibleMarkers.push(layer);
        }
      });

      if (visibleMarkers.length > 0) {
        const markersBounds = L.latLngBounds([visibleMarkers[0].getLatLng()]);
        visibleMarkers.forEach(marker => {
          markersBounds.extend(marker.getLatLng());
        });

        this.$refs.map.$refs.map.mapObject.flyToBounds(markersBounds, {
          padding: L.point(36, 36),
          animate: false
        });
      }
    },
    switchMode() {
      this.mode = this.mode === 'map' ? 'table' : 'map';
    },
    onPageChanged(value) {
      this.$emit('page-changed', value);
    },
    onPerPageChanged(value) {
      this.$emit('per-page-changed', value);
    },
    initMap() {
      this.$nextTick(() => {
        this.$refs.map.$refs.map.mapObject.invalidateSize();
        this.$refs.map.$refs.map.mapObject.setView(
          new L.LatLng(this.marker.location.lat, this.marker.location.lng),
          6
        );
        this.fitMapBounds();
        this.$refs.map.$refs.map.mapObject.removeControl(
          this.$refs.map.$refs.map.mapObject.zoomControl
        );
        L.control
          .zoom({ position: 'topright' })
          .addTo(this.$refs.map.$refs.map.mapObject);
      });
    },
    onNumberOfPointsChanged() {
      this.$emit('numberOfPointsChanged', this.numberOfPoints);
    }
  },
  watch: {
    currentTabType: {
      handler(value) {
        if (value === 'position' && this.mode === 'map') {
          this.initMap();
        }
      }
    },
    mode: {
      handler(value) {
        if (this.currentTabType === 'position' && value === 'map') {
          this.initMap();
        }
      }
    }
  },
  computed: {
    radioOptions() {
      return [
        { text: '<i class="fas fa-table"></i>', value: 'table' },
        { text: '<i class="fas fa-map"></i>', value: 'map' }
      ];
    },
    polylineLocations() {
      let polylines = [];
      const positions = this.measures.map(m => {
        return [m.measure.lat, m.measure.lon];
      });
      polylines = [...polylines, ...positions];
      return polylines;
    },
    marker() {
      return {
        id: this.asset._id,
        name: this.asset._source.reference,
        location: {
          lat: this.asset._source.measures.position.point.lat,
          lng: this.asset._source.measures.position.point.lon
        }
      };
    }
  },
  data() {
    return {
      numberOfPoints: 10,
      checked: false,
      mode: 'table',
      icon: new L.divIcon({
        html: '<i class="fa fa-circle dotsColor"></i>',
        className: 'hearticon',
        shadowUrl,
        iconSize: [8, 8],
        iconAnchor: [8, 8],
        popupAnchor: [1, -34],
        interactive: true
      }),
      markerIcon: new L.divIcon({
        html: '<i class="fa fa-map-marker-alt fa-3x markerColor" ></i>',
        className: 'hearticon',
        shadowUrl,
        iconSize: [20, 36],
        iconAnchor: [15, 36],
        popupAnchor: [1, -34],
        interactive: true
      })
    };
  }
};
</script>

<style lang="scss">
@import '~leaflet.markercluster/dist/MarkerCluster.css';
@import '~leaflet.markercluster/dist/MarkerCluster.Default.css';
.switchButton {
  position: absolute;
  float: left;
  left: 15px;
  margin-top: 17px;
  z-index: 2;
  background-color: white;
}

.markerColor {
  color: map-get($theme-colors, primary);
}

.dotsColor {
  color: map-get($theme-colors, secondary);
}

.lineColor {
  color: map-get($theme-colors, info);
}
</style>
